import React, { FC, PropsWithChildren, useMemo } from 'react';
import { ClientPageResolver, ClientWebPageResolverProvider, coreRouterApi, createRoutesDict } from '@cp/entities/clientWebRoutes';
import { ClientWebRouteViewModel } from '@common/model/meta/clientWebRouteViewModel';

export const ClientWebRouteResolver: FC<PropsWithChildren> = (props) => {
  const { data: routesResponse } = coreRouterApi.endpoints.getClientWebRoutes.useQuery();
  const routesRef = React.useRef<ClientWebRouteViewModel[]>([]);

  const routesDict = React.useMemo(() => {
    if (routesResponse) {
      routesRef.current = routesResponse;
    }

    return createRoutesDict(routesRef.current);
  }, [routesResponse]);

  const resolver = useMemo(() => {
    return new ClientPageResolver(routesDict);
  }, [routesDict]);

  return <ClientWebPageResolverProvider value={resolver}>{props.children}</ClientWebPageResolverProvider>;
};
